export default [
  {
    prefix: '/management/setting',
    children: [],
  },
  {
    path: '/management/app_installer',
    component: () => import('../views/management/AppInstaller.vue'),
  },
  {
    path: '/management/device/deviceIndex',
    component: () => import('../views/management/device/DeviceIndex.vue'),
  },
  {
    path: '/management/help/index',
    component: () => import('../views/management/help/Index.vue'),
  },
  {
    path: '/management/user/index',
    component: () => import('../views/management/help/Index.vue'),
  },
];
